import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { EmailPositionFormGroup } from './email-position-form.helper';

@Component({
  selector: 'app-email-position-form',
  imports: [ReactiveFormsModule, ValidatedInputComponent],
  templateUrl: './email-position-form.component.html',
  styleUrl: './email-position-form.component.scss',
})
export class EmailPositionFormComponent {
  formGroup = input.required<FormGroup<EmailPositionFormGroup>>();
}
